import { useHistory } from 'react-router';
import { Spinner } from '../../../components/common';
import { ROUTE_PATH } from '../../../routes/paths';
import Header from '../../../components/common/global-top-bar';
import { connect, useDispatch } from 'react-redux';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { useEffect, useState } from 'react';
import { fetchTosRequest, updateTosRequest } from './text-blocks-redux/actions';
import draftToHtml from 'draftjs-to-html';
import RichTextEditor from '../../../components/common/rich-text-editor';
import { Location } from 'history';

//@ts-ignore
import htmlToDraft from 'html-to-draftjs';
import RouteLeavingGuard from '../../../components/route-leaving-prompt';

type props = {
  pending: boolean;
  listenerFaq: any;
  peersFaq: any;
};

const ListenerFaqTOS: React.FunctionComponent<props> = ({
  pending,
  listenerFaq,
  peersFaq,
}): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [richText, setRichText] = useState({
    listenerFaq: EditorState.createEmpty(),
    peersFaq: EditorState.createEmpty(),
    listenerFaqSave: true,
    peersFaqSave: true,
  });

  const handleSave = (messageType: string, data: any) => {
    const payload = {
      type: messageType,
      payload: {
        value: convertHTMLtoText(data),
      },
    };
    dispatch(updateTosRequest(payload));
  };

  const convertTextToHTML = (data: string) => {
    const contentBlock = htmlToDraft(data);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
  };

  const convertHTMLtoText = (data: any) => {
    return draftToHtml(convertToRaw(data.getCurrentContent()));
  };

  const handleMessage = (messageType: string, data: any, fromRedux?: boolean) => {
    setRichText((richtext: any) => ({
      ...richtext,
      [messageType]: data,
      [messageType + 'Save']: fromRedux ? true : false,
    }));
  };

  useEffect(() => {
    if (listenerFaq?.status === 200) {
      handleMessage('listenerFaq', convertTextToHTML(listenerFaq.data?.LISTENER_FAQ), true);
    }
  }, [listenerFaq]); //

  useEffect(() => {
    if (peersFaq?.status === 200) {
      handleMessage('peersFaq', convertTextToHTML(peersFaq.data?.PEER_FAQ), true);
    }
  }, [peersFaq]); //peersFaq

  useEffect(() => {
    dispatch(fetchTosRequest({ type: 'LISTENER_FAQ' }));
    dispatch(fetchTosRequest({ type: 'PEER_FAQ' }));
  }, []);

  return (
    <div>
      {pending && <Spinner />}
      <RouteLeavingGuard
        when={!richText.listenerFaqSave || !richText.peersFaqSave}
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: Location) => {
          if (!richText.listenerFaqSave || !richText.peersFaqSave) {
            if (location.pathname !== ROUTE_PATH.LISTENRFAQTOC) {
              return true;
            }
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={
          'You have unsaved changes. Do you want to leave this page and lose your changes?'
        }
        cancelButtonText={'Cancel'}
        confirmButtonText={'Continue and lose changes'}
      />
      <Header heading={'Listeners'} />

      <div className="w-full border-b gray-border-line flex justify-between items-center bg-gray-background-light px-4  h-10 ">
        <div className="   gray-background-dark h-full">
          <button
            className={' text-sm  px-5 py-2 '}
            onClick={() => {
              history.push(ROUTE_PATH.MEMBERSTOC);
            }}
          >
            Members
          </button>
          <button
            className={' text-sm  px-5 py-2 gray-background-dark h-full  '}
            onClick={() => {
              history.push(ROUTE_PATH.CLIENTADMINTOC);
            }}
          >
            Client Administrators
          </button>
          <button
            className={' text-sm  px-5 py-2 bg-blue-primary text-white h-full  font-bold'}
            onClick={() => {
              history.push(ROUTE_PATH.LISTENRFAQTOC);
            }}
          >
            Listeners
          </button>
        </div>
      </div>

      <div className="max-window-height pb-32 pt-4 overflow-y-auto">
        <div>
          <div className="mt-4 w-full px-7">
            <div className="flex justify-between items-end py-2 border-b border-gray-500">
              <p className="pt-4 font-bold text-gray-dark">LISTENERS FAQ</p>
              <button
                className=" rounded-full  text-center h-6 text-sm text-white px-2 stacked-bar-blue-400 disabled:bg-gray-400"
                onClick={() => {
                  handleSave('LISTENER_FAQ', richText.listenerFaq);
                }}
                disabled={richText.listenerFaqSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4 ">
              <RichTextEditor
                RichText={richText?.listenerFaq}
                setRichText={(data: EditorState) => {
                  handleMessage('listenerFaq', data);
                }}
              />
            </div>
          </div>
          <div className="mt-4 w-full px-7">
            <div className="flex justify-between items-end py-2 border-b border-gray-500">
              <p className="pt-4 font-bold text-gray-dark">PEER FAQ </p>
              <button
                className=" rounded-full  text-center h-6 text-sm text-white px-2 stacked-bar-blue-400 disabled:bg-gray-400"
                onClick={() => {
                  handleSave('PEER_FAQ', richText.peersFaq);
                }}
                disabled={richText.peersFaqSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4 ">
              <RichTextEditor
                RichText={richText?.peersFaq}
                setRichText={(data: EditorState) => {
                  handleMessage('peersFaq', data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pending: state.Tos?.pending || null,
    listenerFaq: state.Tos.listenerFaq || null,
    peersFaq: state.Tos.peersFaq || null,
  };
};

export default connect(mapStateToProps)(ListenerFaqTOS);
